// import logger from '../lib/utils/logger'
import db from '../store/local.js'
import {DEFAULT_EXPIRE, K_LOGINED_USER, MSG_ID} from '../lib/constant'
// require('../lib/utils/cryptojs/cryptojs.js') // code executes and sets the object 'Crypto' in window object
// let crypto = window.Crypto
// end
/**
 * User structure
 * {
    name: 'state for login user',
    desc: 'platform description',
    application_id: 1,
    authedActions: [],
    account: null,
    session: null,
    accountPwd: null,
    lastLoginTime: 0
  }
 */
export default {
  mounted: function () {
    // tH
    // console.log('here mixins 写死的')
    // let user = {
    //   application_id: 1,
    //   authedActions: [],
    //   account: '123456',
    //   session: '123456',
    //   accountPwd: crypto.MD5('123456'),
    //   lastLoginTime: Date.now() / 1000 + DEFAULT_EXPIRE
    // }
    // db.save(K_LOGINED_USER, user)
    // console.log('登录成功')
    // end

    let user = db.get(K_LOGINED_USER)
    if (!user || !user.account || (user.lastLoginTime + DEFAULT_EXPIRE) < (Date.now() / 1000)) {
      window.emitter.emit(MSG_ID.MSG_SYS_EXIT)
      return
    }
    console.log('logon length ', (user.lastLoginTime + DEFAULT_EXPIRE) - (Date.now() / 1000))
    if (((user.lastLoginTime + DEFAULT_EXPIRE) - (Date.now() / 1000)) < DEFAULT_EXPIRE / 2) {
      window.emitter.emit(MSG_ID.MSG_SYS_REAUTH)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/guard.js